import React from 'react';
import { flatMap, get } from 'lodash';
import isNZProduct from 'utils/IsNZProduct';
import {
  convertPrice,
  getProductTotalPrice,
  formatToTwoDecimalPlaces,
} from 'utils/pricingUtils';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { MinTotalPriceProps } from './type';
import { MinYearlyTotalView } from './MinYearlyTotalView';
import { MinTotalPriceView } from '../minTotalPrice/MinTotalPriceView';

export const MinYearlyTotalPrice: React.FC<MinTotalPriceProps> = ({
  productData,
  addOnProductsData = []
}) => {
  const { isAnnualPrice } = useSessionContext();
  const productItems = get(productData, 'items', []);
  const productItem = productItems[0];

  if (!productItem) {
    return null;
  }

  const productId = productItem.productId;
  const gstLabel = isNZProduct(productId) ? '(+ GST)' : '(inc. GST)';

  const hasAddonProducts = addOnProductsData.length > 0;
  if (hasAddonProducts) {

    const addOnProductItems = flatMap(addOnProductsData, (addOnProduct) => addOnProduct.items ?? []);
    const yearlyTotalPrice = formatToTwoDecimalPlaces(
      convertPrice(getProductTotalPrice([...productItems, ...addOnProductItems]), 12)
    );

    return (
      <MinYearlyTotalView
        minTotalPrice={yearlyTotalPrice}
        currency={productItem.currency}
        gstLabel={gstLabel}
      />
    );
  }

  const minTotalPrice = formatToTwoDecimalPlaces(getProductTotalPrice(productItems));
  return (
    <MinTotalPriceView
      isAnnualPrice={isAnnualPrice}
      minTotalPrice={minTotalPrice}
      productItems={productItems}
    />
  );
};